<script lang="ts">
  import {
    openPostDetailsModal,
    postinDetailsModal,
    selectedPostDetailsTab,
  } from '$src/stores'
  import { fade } from 'svelte/transition'
  import Modal from './SmallModal/Modal.svelte'
  import { expoOut } from 'svelte/easing'
  import PostDetailsModalUser from './PostDetailsModalUser.svelte'
  import { me } from '$src/stores/user.store'
  import { getPostDonations } from '$src/utils/api/donation.util'
  import LoaderRows from '$lib/components/common/loaders/LoaderRows.svelte'
  import Close from '$icons/CloseAltIcon.svelte'

  let loadingIds: string[] = [];
  let donations: any[] = [];

  function closePostModal() {
    openPostDetailsModal.set(false);
    donations = [];
    loadingIds = [];
  }

  $: if ($postinDetailsModal) {
    getDonations();
  }
  const getDonations = async () => {
    donations = await getPostDonations({ donationValue: -1 }, $postinDetailsModal._id);
  };
</script>

{#if $openPostDetailsModal && $postinDetailsModal}
  <Modal
    on:ModalClose={closePostModal}
    class="w-[475px] h-[625px] scrollbar-hide"
    disablePadding
    hideCloseButton
    contentOverflow={false}
    disableBorder
    overlayCls="!px-20"
    transparentBackground
  >
    <div
      class="h-full bg-white relative overflow-auto px-3 py-8 flex flex-col"
      slot="content"
      transition:fade|global={{ duration: 600, easing: expoOut }}
    >
      <button on:click={closePostModal} class="absolute right-2 bg-[#F4F5F9] p-2 rounded-[8px]">
        <Close />
      </button>
      <div class="flex gap-3 text-blueish-grey-400 font-bold mb-3">
        <button
          on:click={() => {
            selectedPostDetailsTab.set('likes');
          }}
          class:selected-tab={$selectedPostDetailsTab === 'likes'}
          class="flex gap-2 items-center text-base py-1"
        >
          <span>Likes</span>
          <span
            class="text-sm rounded-[5px] w-[18px] h-[18px] flex items-center
            justify-center bg-blueish-grey-100 font-medium"
          >
            {$postinDetailsModal.likes.length}
          </span>
        </button>

        <button
          on:click={() => {
            selectedPostDetailsTab.set('seeds');
          }}
          class:selected-tab={$selectedPostDetailsTab === 'seeds'}
          class="flex gap-2 items-center text-base py-1"
        >
          <span>Seeds</span>
          <span
            class="text-sm rounded-[5px] w-[18px] h-[18px] flex items-center
            justify-center bg-blueish-grey-100 font-medium"
          >
            {donations.length}
          </span>
        </button>

        <button
          on:click={() => {
            selectedPostDetailsTab.set('saves');
          }}
          class:selected-tab={$selectedPostDetailsTab === 'saves'}
          class="flex gap-2 items-center text-base py-1"
        >
          <span>Savers</span>
          <span
            class="text-sm rounded-[5px] w-[18px] h-[18px] flex items-center
            justify-center bg-blueish-grey-100 font-medium"
          >
            {[...new Set($postinDetailsModal.savers)].length}
          </span>
        </button>
      </div>
      <div class="max-h-[calc(100%-60px)] overflow-y-auto">
        {#if $selectedPostDetailsTab === 'likes'}
          <div class="m-4">
            {#each $postinDetailsModal.likes as userId}
              <PostDetailsModalUser {userId} bind:loadingIds me={$me} />
            {:else}
              <div class="w-full p-5 text-center text-sm text-black/20 mt-3">No one's here</div>
            {/each}
          </div>
        {:else if $selectedPostDetailsTab === 'saves'}
          <div class="m-4">
            {#each [...new Set($postinDetailsModal.savers)] as userId}
              <PostDetailsModalUser {userId} bind:loadingIds me={$me} />
            {:else}
              <div class="w-full p-5 text-center text-sm text-black/20 mt-3">No Saves Yet</div>
            {/each}
          </div>
        {:else if $selectedPostDetailsTab === 'seeds'}
          <div class="my-4">
            {#if $postinDetailsModal.totalDonationsSeed > 0 && donations.length === 0}
              <LoaderRows height={50} rows={7} />
            {/if}
            {#each donations as donation, i}
              <div class={i === 0 ? 'rounded-[8px] bg-[#F4F5F9] pt-2 pb-4 px-3' : 'mt-4 px-3'}>
                {#if i === 0}
                  <p class="text-accent-blue-70 font-bold text-xs mb-2">Highest donation</p>
                {/if}
                <PostDetailsModalUser {donation} bind:loadingIds me={$me} showTopDonor={i === 0} />
              </div>
            {:else}
              <div class="w-full p-5 text-center text-sm text-black/20 mt-3">No Donations Yet</div>
            {/each}
          </div>
        {/if}
      </div>
    </div>
  </Modal>
{/if}

<style lang="postcss">
  .selected-tab {
    @apply border-b-2 border-blueish-grey-900 transition-all;
    color: #091f37;
  }
</style>
